
import consentCookieMixin from "@/mixins/consentCookieMixin"
import OImage from "@/components/base/image/OImage"
import { routeToDatenschutz } from "@/helpers/routing"
export default {
    name: "VideoCookiePlaceholder",
    components: { OImage },
    mixins: [consentCookieMixin],
    data: () => ({
        routeToDatenschutz,
    }),
}
